export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7123.4265a9fd.jpg";